import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/logo-sigel.png'


const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark fixed-top" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "logo-text" }
const _hoisted_5 = { class: "user-section" }
const _hoisted_6 = {
  key: 0,
  class: "loja-selector"
}
const _hoisted_7 = { value: 0 }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["title"]
const _hoisted_10 = { class: "notification-container" }
const _hoisted_11 = {
  key: 0,
  class: "notification-badge"
}
const _hoisted_12 = {
  key: 0,
  class: "notification-dropdown"
}
const _hoisted_13 = { class: "notification-header" }
const _hoisted_14 = { class: "notification-list" }
const _hoisted_15 = {
  key: 0,
  class: "no-notifications"
}
const _hoisted_16 = { class: "notification-content" }
const _hoisted_17 = { class: "notification-title" }
const _hoisted_18 = { class: "notification-message" }
const _hoisted_19 = { class: "notification-time" }
const _hoisted_20 = { class: "notification-footer" }
const _hoisted_21 = { class: "user-profile" }
const _hoisted_22 = { class: "user-info" }
const _hoisted_23 = { class: "user-details" }
const _hoisted_24 = { class: "user-name" }
const _hoisted_25 = { class: "user-role" }
const _hoisted_26 = { class: "user-dropdown" }
const _hoisted_27 = {
  key: 0,
  class: "user-dropdown-menu"
}

import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "@/stores/admin/authStore";
import { useTheme } from "@/composables/useTheme";
import { setLocale } from "@/i18n";
import { useI18n } from "vue-i18n";
import { useTableView } from "@/composables/useTableView";
import NotificacaoService from "@/services/admin/NotificacaoService";
import type { NotificacaoSistemaResponse } from "@/models/response/admin/NotificacaoSistemaResponse";
import api from "@/plugins/axios";
import SearchableSelect from '@/components/SearchableSelect.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  emits: ['toggleSidebar'],
  setup(__props) {

// TODO F44: Navbar component is too large (~300 lines). Consider extracting notification panel,
// loja selector, and user dropdown into separate components.

const { isDark, toggleTheme } = useTheme();
const { locale } = useI18n();
const currentLocale = computed(() => locale.value);
const toggleLocale = () => {
  const newLocale = locale.value === 'pt-BR' ? 'en' : 'pt-BR';
  setLocale(newLocale);
};

const router = useRouter();
const route = useRoute();
const authStore = useAuthStore();

// Navbar collapse (right drawer)
const navbarCollapseOpen = ref(false);
const navbarCollapseRef = ref<HTMLElement | null>(null);
const navbarTogglerRef = ref<HTMLElement | null>(null);

const toggleNavbarCollapse = () => {
  navbarCollapseOpen.value = !navbarCollapseOpen.value;
};

const closeNavbarCollapse = () => {
  navbarCollapseOpen.value = false;
};

// Fechar ao navegar para outra pagina
watch(() => route.fullPath, () => {
  closeNavbarCollapse();
});

// State
const showNotifications = ref(false);
const showUserDropdown = ref(false);
const notificationCount = ref(0);
const nomeLoja = ref("");
const ultimasNotificacoes = ref<NotificacaoSistemaResponse[]>([]);
const lojasUsuario = ref<{ lojaId: number; nome: string }[]>([]);
const lojaSelecionada = ref<number | null>(authStore.lojaId);
const { visualizacaoTabela, setView } = useTableView();
const visualizacaoAtual = ref(visualizacaoTabela.value);

// Computed
const userRole = computed(() => {
  const roles = authStore.getRoles || [];
  if (roles.includes("Administrador")) return "Administrador";
  if (roles.includes("Gerente")) return "Gerente";
  if (roles.includes("Vendedor")) return "Vendedor";
  if (roles.includes("Operador de Caixa")) return "Operador de Caixa";
  if (roles.includes("Controlador de Estoque")) return "Controlador de Estoque";
  return roles[0] || "Usuario";
});

// Notificacoes
const carregarNotificacoes = async () => {
  try {
    const page = await NotificacaoService.findAll({ page: 0, size: 3, sort: 'dataHora,desc' });
    ultimasNotificacoes.value = page?.content || [];
    try {
      notificationCount.value = await NotificacaoService.contarNaoLidas();
    } catch (e) {
      console.error('[Navbar] Erro ao contar notificacoes nao lidas:', e)
      notificationCount.value = ultimasNotificacoes.value.filter(n => !n.lida).length;
    }
  } catch (e) {
    console.error('[Navbar] Erro ao carregar notificacoes:', e)
    ultimasNotificacoes.value = [];
    notificationCount.value = 0;
  }
};

const getNotificacaoIcon = (tipo: string): string => {
  const map: Record<string, string> = {
    ESTOQUE: 'fas fa-boxes',
    VENDA: 'fas fa-shopping-cart',
    ENTREGA: 'fas fa-shipping-fast',
    FINANCEIRO: 'fas fa-dollar-sign',
    SISTEMA: 'fas fa-cog',
    TROCA_REGISTRADA: 'fas fa-exchange-alt',
    PARCELA_VENCIDA: 'fas fa-exclamation-triangle',
  };
  return map[tipo] || 'fas fa-bell';
};

const formatarTempo = (dataHora: string): string => {
  if (!dataHora) return '';
  try {
    const data = new Date(dataHora);
    const agora = new Date();
    const diffMin = Math.floor((agora.getTime() - data.getTime()) / 60000);
    if (diffMin < 1) return 'Agora';
    if (diffMin < 60) return `${diffMin}min atras`;
    const diffHoras = Math.floor(diffMin / 60);
    if (diffHoras < 24) return `${diffHoras}h atras`;
    const diffDias = Math.floor(diffHoras / 24);
    if (diffDias < 7) return `${diffDias}d atras`;
    return data.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
  } catch (e) { console.error('[Navbar] Erro ao formatar tempo:', e); return dataHora; }
};

// Loja
const carregarLojas = async () => {
  try {
    const { data } = await api.get<{ lojaId: number; nome: string }[]>('/usuario/lojas');
    lojasUsuario.value = data;
  } catch (e) {
    console.error('[Navbar] Erro ao carregar lojas:', e);
    lojasUsuario.value = [];
  }
};

const trocarLoja = () => {
  if (lojaSelecionada.value === 0) {
    router.push({ name: 'DashboardMultiLoja' });
    return;
  }
  if (lojaSelecionada.value) {
    authStore.setLojaId(lojaSelecionada.value);
    const loja = lojasUsuario.value.find(l => l.lojaId === lojaSelecionada.value);
    if (loja) authStore.setNomeLoja(loja.nome);
    window.location.reload();
  }
};

// Methods
const logout = () => { authStore.logout(); router.push({ name: "Login" }); };

const toggleNotifications = () => {
  showNotifications.value = !showNotifications.value;
  showUserDropdown.value = false;
  if (showNotifications.value) carregarNotificacoes();
};

const toggleUserDropdown = () => {
  showUserDropdown.value = !showUserDropdown.value;
  showNotifications.value = false;
};

const markAllAsRead = async () => {
  try {
    await NotificacaoService.marcarTodasComoLidas();
    notificationCount.value = 0;
    ultimasNotificacoes.value.forEach(n => { n.lida = true; });
  } catch (e) { console.error('[Navbar] Erro ao marcar notificacoes como lidas:', e) }
};

const alterarVisualizacao = () => {
  setView(visualizacaoAtual.value);
  // Keep DOM event for views that still listen via window events
  window.dispatchEvent(new CustomEvent("alterar-visualizacao-tabela", { detail: visualizacaoAtual.value }));
};

const handleClickOutside = (event: Event) => {
  const target = event.target as HTMLElement;
  if (!target.closest(".notification-container") && !target.closest(".user-profile") && !target.closest(".view-style-dropdown")) {
    showNotifications.value = false;
    showUserDropdown.value = false;
  }
  // Fechar navbar collapse ao clicar fora
  if (navbarCollapseOpen.value && !target.closest("#navbarResponsive") && !target.closest(".navbar-toggler")) {
    closeNavbarCollapse();
  }
};

// Lifecycle
let pollInterval: ReturnType<typeof setInterval> | null = null;

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
  nomeLoja.value = authStore.nomeLoja;
  carregarNotificacoes();
  carregarLojas();
  pollInterval = setInterval(carregarNotificacoes, 60000);
});

onUnmounted(() => {
  document.removeEventListener("click", handleClickOutside);
  if (pollInterval) clearInterval(pollInterval);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "sidebar-toggle-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleSidebar'))),
        "aria-label": "Toggle sidebar"
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("i", { class: "fas fa-bars" }, null, -1)
      ])),
      _createVNode(_component_router_link, {
        to: "/home",
        class: "navbar-brand logo-container"
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createElementVNode("img", {
            src: _imports_0,
            class: "logo-img",
            alt: "SisGel Logo"
          }, null, -1)
        ])),
        _: 1
      }),
      _createElementVNode("button", {
        ref_key: "navbarTogglerRef",
        ref: navbarTogglerRef,
        class: "navbar-toggler custom-toggler",
        type: "button",
        onClick: toggleNavbarCollapse,
        "aria-controls": "navbarResponsive",
        "aria-expanded": navbarCollapseOpen.value,
        "aria-label": "Toggle navigation"
      }, _cache[6] || (_cache[6] = [
        _createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)
      ]), 8, _hoisted_3),
      _createElementVNode("div", {
        class: _normalizeClass(["navbar-collapse", { show: navbarCollapseOpen.value }]),
        id: "navbarResponsive",
        ref_key: "navbarCollapseRef",
        ref: navbarCollapseRef
      }, [
        _createElementVNode("span", _hoisted_4, " Sistema de Gerenciamento de Loja - " + _toDisplayString(nomeLoja.value), 1),
        _createElementVNode("div", _hoisted_5, [
          (lojasUsuario.value.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-store" }, null, -1)),
                _createVNode(SearchableSelect, {
                  modelValue: lojaSelecionada.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((lojaSelecionada).value = $event)),
                  onChange: trocarLoja,
                  class: "form-select"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t('multiLoja.todasAsLojas')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lojasUsuario.value, (loja) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: loja.lojaId,
                        value: loja.lojaId
                      }, _toDisplayString(loja.nome), 9, _hoisted_8))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "theme-toggle-btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(toggleTheme) && _unref(toggleTheme)(...args))),
            title: _unref(isDark) ? 'Modo claro' : 'Modo escuro',
            "aria-label": "Alternar tema"
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(_unref(isDark) ? 'fas fa-sun' : 'fas fa-moon')
            }, null, 2)
          ], 8, _hoisted_9),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "notification-btn",
              onClick: toggleNotifications,
              "aria-label": "Notificacoes"
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-bell" }, null, -1)),
              (notificationCount.value > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(notificationCount.value > 99 ? '99+' : notificationCount.value), 1))
                : _createCommentVNode("", true)
            ]),
            (showNotifications.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h6", null, _toDisplayString(_ctx.$t('notificacao.title')), 1),
                    (notificationCount.value > 0)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          onClick: markAllAsRead,
                          class: "mark-all-read"
                        }, _toDisplayString(_ctx.$t('notificacao.marcarTodasLidas')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    (ultimasNotificacoes.value.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-bell-slash" }, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('notificacao.notFound')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ultimasNotificacoes.value, (n) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: n.notificacaoId,
                        class: _normalizeClass(["notification-item", { unread: !n.lida }])
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass([getNotificacaoIcon(n.tipo), "notification-icon"])
                        }, null, 2),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, _toDisplayString(n.titulo), 1),
                          _createElementVNode("div", _hoisted_18, _toDisplayString(n.mensagem), 1),
                          _createElementVNode("div", _hoisted_19, _toDisplayString(formatarTempo(n.dataHora)), 1)
                        ])
                      ], 2))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_router_link, {
                      to: "/notificacoes",
                      class: "ver-mais-link",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (showNotifications.value = false))
                    }, {
                      default: _withCtx(() => [
                        _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-list" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.details')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "user-avatar" }, [
                _createElementVNode("i", { class: "fas fa-user" })
              ], -1)),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(authStore).getUser || "Usuario"), 1),
                _createElementVNode("span", _hoisted_25, _toDisplayString(userRole.value), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                class: "user-dropdown-btn",
                onClick: toggleUserDropdown,
                "aria-label": "User menu"
              }, _cache[12] || (_cache[12] = [
                _createElementVNode("i", { class: "fas fa-chevron-down" }, null, -1)
              ])),
              (showUserDropdown.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_component_router_link, {
                      to: "/meu-perfil",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fas fa-user-edit" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.meuPerfil')), 1)
                      ]),
                      _: 1
                    }),
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1)),
                    _createElementVNode("button", {
                      onClick: logout,
                      class: "dropdown-item logout-item"
                    }, [
                      _cache[14] || (_cache[14] = _createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('common.close')), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}
}

})